import { Icon } from "armstrong-react";
import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router";
import { push } from "react-router-redux";

import * as WebRoutes from "@travellocal/utils/webRoutes";
import { FlowBox } from "../../../../../core/atoms/atoms";
import { apiPromiseHook } from "../../../../../shared/flux/actions/enterHooks";
import { GoogleAnalyticsHelper } from "@travellocal/ui";
import { combineStateStatuses, MatchState, MatchStateStatus } from "../../../../../shared/helpers/reduxHelpers";
import { CustomerPaymentDetail } from "../../../../components/customer/customerPaymentDetail";
import { CustomerPaymentSummary } from "../../../../components/customer/customerPaymentSummary";
import { RoutesInvoker } from "../../../../routesInvoker";
import { EnterHookPromises } from "../../../../state/enterHookPromises";

import "./payment.scss";

interface StateProps {
  ltoState: IState<ILto>;
  enquiryState: IState<IEnquiry>;
  allItinerariesState: IKeyedState<IState<IEnquiryItinerarySummary>>;
  paymentsState: IState<IPaymentsOutput>;
}

interface DispatchProps {
  navigateToPath: (path: string) => void;
}

type Props = DispatchProps & StateProps;

interface State {
  status: string;
  bookedLogged: boolean;
}

class CustomerEnquiryPaymentComponent extends React.Component<Props, State> {
  public constructor(props) {
    super(props);
    this.state = {
      status: "",
      bookedLogged: false,
    };
  }

  public componentWillMount() {
    const q = (this.props as any).location.query;
    if (q) {
      this.setState({ status: q.result });
    }
  }

  public componentWillReceiveProps() {
    if (this.state.status === "payment-success" && this.props.paymentsState.data.payments.length === 1 && !this.state.bookedLogged) {
      this.setState({ bookedLogged: true });
      GoogleAnalyticsHelper.logEvent("Booked", "Payment success", "Payment tab", null, this.props.enquiryState.data.reference);
    }
  }

  public render() {
    const { ltoState, enquiryState, allItinerariesState, paymentsState } = this.props;

    return (
      <div className="customer-enquiry-payment">
        {this.state.status === "payment-success" &&
          <div className={`p-top-small p-bottom-small payment-successful-message`}>
            <div className="width-wrapper">
              <Icon icon={Icon.Icomoon.checkmark} className="m-right-small" />
              Your payment was successful. Thanks for booking through TravelLocal! Please head to the home tab for more information.
            </div>
          </div>
        }
        {this.state.status === "payment-failure" &&
          <div className={`fg-white p-top-small p-bottom-small bg-negative`}>
            <div className="width-wrapper">
              <Icon icon={Icon.Icomoon.cross} className="m-right-small" />Unfortunately, your payment has failed. Please try making your payment again. You have not been charged.
            </div>
          </div>
        }

        {MatchStateStatus(combineStateStatuses(enquiryState.status, paymentsState.status, ltoState.status), {
          ok: () => {
            const enquiry = enquiryState.data!;

            if (!enquiry.isConnected) {
              return (
                <FlowBox className="marketing-2cols-sidebar width-wrapper">
                  <header>
                    <h1>Payment history</h1>
                  </header>
                  <p>There are no payments to show.</p>
                  <p><Link to={RoutesInvoker.customerIndex}>Back to home</Link></p>
                </FlowBox>
              );
            }

            const payments = paymentsState.data.payments;
            const itineraryState = allItinerariesState.data[enquiry.currentQuoteId];

            return (
              <FlowBox className="marketing-2cols-sidebar width-wrapper">
                <div className="main">
                  <header>
                    <h1>Payment history</h1>
                  </header>

                  {MatchState(itineraryState, {
                    none: () => (
                      <p>Could not load itinerary details.</p>
                    ),
                    data: itinerary => (
                      <CustomerPaymentDetail
                        lto={ltoState.data}
                        customerEnquiry={enquiryState.data}
                        paidDeposit={payments.length !== 0}
                        departureDate={enquiry.currentItinerarySummary ? enquiry.currentItinerarySummary.startDate : null}
                        paidSoFar={enquiry.totalPaid}
                        totalCost={enquiry.currentItinerarySummary ? enquiry.currentItinerarySummary.totalPrice : null}
                        payments={payments}
                        balanceDueDays={itinerary.paymentTerms.balanceDueDays}
                      />
                    ),
                  })}
                </div>

                <div className="sidebar">
                  {MatchState(itineraryState, {
                    none: () => (
                      <p>Could not load itinerary details.</p>
                    ),
                    data: itinerary => (
                      <CustomerPaymentSummary
                        audience={UserType.Customer}
                        enquiry={enquiryState.data}
                        depositPaid={payments.length !== 0}
                        itineraryQuote={itinerary}
                        isBookable={true}
                        lto={ltoState.data}
                        bookingRoute={WebRoutes.customerEnquiryMakePayment(enquiry.id)}
                        balanceDueDays={itinerary.paymentTerms.balanceDueDays}
                      />
                    ),
                  })}
                </div>
              </FlowBox>
            );
          },
        })}
      </div>
    );
  }
}

const stateToProps = (state: IWebStoreState): StateProps => {
  return {
    ltoState: state.lto,
    enquiryState: state.customerEnquiry,
    allItinerariesState: state.customerItineraries,
    paymentsState: state.customerEnquiryPayments,
  };
};

const dispatchToProps = (dispatch): DispatchProps => {
  return {
    navigateToPath: (path: string) => dispatch(push(path)),
  };
};

export const Payment = connect(stateToProps, dispatchToProps)(CustomerEnquiryPaymentComponent);

export const paymentOnEnter = apiPromiseHook<any>(
  EnterHookPromises.enquiryItineraryFromRoute(),
  EnterHookPromises.paymentsByEnquiryId("enquiryId"),
);
